import { Routes } from '@angular/router';

import { termsRootRoute } from '@terms-conditions/terms-routing.module';
import { privacyPolicyRootRoute } from '@privacy-policy/privacy-policy-routing.module';
import { rightRepentanceRootRoute } from '@right-repentance/right-repentance-routing.module';
import { responsableTourismRootRoute } from '@responsable-tourism/responsable-tourism-routing.module';
import { treatmentRootRoute } from '@treatment-personal-data/treatment-routing.module';
import { 
  TERMS_CONDITIONS, PRIVACY_POLICY, RIGHT_REPENTANCE, RESPONSABLE_TOURISM, TREATMENT_PERSONAL_DATA
} from '@app/constants/route-titles.constants';
import { specialTravelDataRootRoute } from '@app/modules/special-travel-data/special-travel-data.routing.module';
import { RoutingLevel } from '@ux/animations/animations';
import { HeaderType } from '@design-system/components/templates/header/entities/header.types';
import { HeaderPageType } from '@header/entities/ds-header-config';

export const policiesAndTermsRoutes: Routes = [
  {
    path: termsRootRoute, loadChildren: () =>
      import('../modules/terms-conditions/terms.module').then(m => m.TermsModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: TERMS_CONDITIONS,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: privacyPolicyRootRoute, loadChildren: () =>
      import('../modules/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: PRIVACY_POLICY,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: rightRepentanceRootRoute, loadChildren: () =>
      import('../modules/right-repentance/right-repentance.module').then(m => m.RightRepentanceModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: RIGHT_REPENTANCE,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: responsableTourismRootRoute, loadChildren: () =>
      import('../modules/responsable_tourism/responsable-tourism.module').then(m => m.ResponsableTourismModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: RESPONSABLE_TOURISM,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: treatmentRootRoute, loadChildren: () =>
      import('../modules/treatment-personal-data/treatment-personal-data.module').then(m => m.TreatmentPersonalDataModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: TREATMENT_PERSONAL_DATA,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
  {
    path: specialTravelDataRootRoute, loadChildren: () =>
      import('../modules/special-travel-data/special-travel-data.module').then(m => m.SpecialTravelDataModule),
    data: {
      routingLevel: RoutingLevel.Nine,
      dsHeaderConfig: {
        type: HeaderType.Generic,
        titleKey: null,
        pageType: HeaderPageType.InfoPage,
      },
    }
  },
];
